import { call, put, takeEvery } from 'redux-saga/effects';

import * as types from './constants';
import * as actions from './actions';
import { handleErrors, fetch } from '../../../api';
import api from '../../../api/endpoints';

function* createReimbursement({ payload: { values, onSuccess, handledErrors } }) {
  try {
    const { data } = yield call(fetch, { api: api.reimbursements.create, data: values });

    onSuccess && onSuccess(data.result);
    yield put(actions.createReimbursementDone(data.result));
  } catch (error) {
    yield handleErrors({
      error,
      putErrorData: actions.createReimbursementFailed,
      handledErrors,
      endpoint: api.reimbursements.create.url
    });
  }
}

export const createReimbursementSaga = takeEvery(types.CREATE_REIMBURSEMENT_REQUEST, createReimbursement);